import { useEffect, useState } from "react";

export const useFirstName = () => {
  const [firstName, setFirstName] = useState('');

  useEffect(() => {
    window['firstName']?.then(setFirstName);
  }, []);

  return firstName;
};
